import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-md-5 mb-lg-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "d-none d-lg-flex d-flex align-items-center text-dark fw-bolder fs-3 my-1" }, " My Memberships ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-flex h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_4 = { class: "d-none d-md-flex overflow-auto h-55px" }
const _hoisted_5 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  key: 0,
  class: "badge badge-light-primary badge-circle fw-bolder fs-7 mx-2 text-white"
}
const _hoisted_9 = { class: "d-none d-md-flex py-1 ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link text-active-primary me-6", {'active': _ctx.applicationStore.ui.user.memberships.tab === 'memberships'}]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab('memberships')))
            }, "Memberships", 2)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link text-active-primary me-6", {'active': _ctx.applicationStore.ui.user.memberships.tab === 'requests'}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab('requests')))
            }, [
              _createTextVNode("Requests & Invitations "),
              (_ctx.userStore.invitations.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.userStore.invitations.length), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Button, {
        onClick: _ctx.toggleRequestAccess,
        class: "btn-sm"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Request Access")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}